import { useState, useEffect } from 'react';
import { JugadorDto } from '../types/jugador';
import { jugadorService } from '../services/JugadorService';

/**
 * Hook para obtener jugadores del equipo activo del entrenador
 */
export const useJugadoresEquipoActivo = () => {
  const [jugadores, setJugadores] = useState<JugadorDto[]>([]);
  const [temporada, setTemporada] = useState<{id: number, nombre: string, fechaInicio: string, fechaFin: string} | null>(null);
  const [equipo, setEquipo] = useState<{id: number, nombre: string, seccion?: string} | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const obtenerJugadores = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await jugadorService.getJugadoresEquipoActivo();
      
      if (response.success && response.data) {
        setJugadores(response.data.jugadores || []);
        setTemporada(response.data.temporada);
        setEquipo(response.data.equipo);
      } else {
        setError(response.message || 'Error al obtener jugadores');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error desconocido');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    obtenerJugadores();
  }, []); 

  return { 
    jugadores, 
    temporada,
    equipo,
    loading, 
    error, 
    refetch: obtenerJugadores 
  };
};